import { render, staticRenderFns } from "./DocumentSignature.vue?vue&type=template&id=bc3ba49a&scoped=true"
import script from "./DocumentSignature.vue?vue&type=script&lang=ts"
export * from "./DocumentSignature.vue?vue&type=script&lang=ts"
import style0 from "./DocumentSignature.vue?vue&type=style&index=0&id=bc3ba49a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3ba49a",
  null
  
)

export default component.exports